import moment from "moment";
import RecordClassCreator from "services/record";

export default class StatsAnswersOverviewRecord extends RecordClassCreator({
  type: "statsAnswersOverviewRecord",

  /** @memberof StatsAnswersOverviewRecord# */
  date: undefined,

  /** @memberof StatsAnswersOverviewRecord# */
  total: undefined,

  /** @memberof StatsAnswersOverviewRecord# */
  timeSeriesUnit: "day"
}) {
  /**
   * @returns {String}
   */
  get chartAxisLabel() {
    switch (this.timeSeriesUnit) {
      case "month": return moment(this.date).format("MMM 'YY");
      case "week": return moment(this.date).format("MMM D");
      default: return moment(this.date).format("MMM D");
    }
  }

  /**
   * @returns {String}
   */
  get tooltipLabel() {
    const date = moment(this.date);

    switch (this.timeSeriesUnit) {
      case "month":
        return date.format("MMMM, YYYY");
      case "week":
        return `Week of ${date.format("MMMM D, YYYY")}`;
      default:
        return date.format("dddd, MMMM D, YYYY");
    }
  }
}
